import { useEffect } from 'react';
import { initSentry, type SentryOptions } from './initSentry';

// @ai-generated 2026-10-29T10:59:52+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
/** Runs Sentry for as long as the component is mounted, and restarts it when an option changes. */
export function useSentry({
    enabled,
    dsn,
    sendDefaultPii,
    environment,
    debug,
    release,
    tracesSampleRate,
}: SentryOptions) {
    useEffect(() => {
        const sentryClient = initSentry({
            enabled,
            dsn,
            sendDefaultPii,
            environment,
            debug,
            release,
            tracesSampleRate,
        });

        return () => {
            sentryClient?.close();
        };
    }, [enabled, dsn, sendDefaultPii, environment, debug, release, tracesSampleRate]);
}
